import fetch from "../fetch";

export default ({ fundId, placementAgentId }) =>
  fetch({
    path: `/hy/funds/${fundId}/placement-agents/${placementAgentId}`,
    method: "DELETE",
  });
